import { render, staticRenderFns } from "./customFormBuildEdit.vue?vue&type=template&id=31258444&scoped=true"
import script from "./customFormBuildEdit.vue?vue&type=script&lang=js"
export * from "./customFormBuildEdit.vue?vue&type=script&lang=js"
import style0 from "./customFormBuildEdit.vue?vue&type=style&index=0&id=31258444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31258444",
  null
  
)

export default component.exports